<div class="landing-page">
  @if (carrierData?.companyLogo) {
    <div class="carrier-logo-box">
      <img [src]="carrierData?.companyLogo" alt="Carrier Logo" />
    </div>
  } @else {
    <div class="ellipse-icon">
      <img src="/assets/images/fleetoperate.png" alt="FleetOperate Logo" />
    </div>
  }


  @if (carrierData) {
    <div class="headline">
      Welcome to <strong>{{ carrierData?.companyName }}</strong>
    </div>
  }

  <div class="sub-headline">
    Join our team and drive with us!
  </div>

  <!-- <div class="info-box">
    <p>
      To apply, Log in with your existing <strong>FleetOperate</strong> Driver account, or create a new account.
    </p>
  </div> -->
  <div class="info-box">
    <p>
      <strong>If you already have a FleetOperate Driver profile that is 100% complete, please login and apply.</strong>
    </p>
  </div>

  <button mat-raised-button class="sign-in-button" (click)="onNavigateToSignIn()">Login to Apply</button>

  <!--
  <div class="signup-text">
    Don’t have an account? <a class="sign-up-link" (click)="onNavigateToSignUp()">Sign up</a>
  </div>
  -->
  <div class="info-box">
    <p>
      <strong>If you do not yet have a complete FleetOperate Driver profile, create one, complete it, and then return here.</strong>
    </p>
  </div>
  <button mat-raised-button class="sign-up-button" (click)="onNavigateToSignUp()">Sign up</button>

  <div class="footer">
    <span>Powered by</span>
    <img src="/assets/images/fleetoperate-logo.png" alt="FleetOperate Logo" />
  </div>
</div>